import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminProtectedRoute } from "@/components/admin/AdminProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Canvas from "./pages/Canvas";
import SharePage from "./pages/SharePage";
import NotFound from "./pages/NotFound";
import AdminOverview from "./pages/admin/AdminOverview";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminWaitlist from "./pages/admin/AdminWaitlist";
import AdminStorage from "./pages/admin/AdminStorage";
import AdminAIUsage from "./pages/admin/AdminAIUsage";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminErrorReporting from "./pages/admin/AdminErrorReporting";
import Onboarding from "./pages/Onboarding";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route 
              path="/canvas" 
              element={
                <ProtectedRoute>
                  <Canvas />
                </ProtectedRoute>
              } 
            />
            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <Onboarding />
                </ProtectedRoute>
              }
            />
            <Route path="/share/:token" element={<SharePage />} />
            <Route path="/share/board/:token" element={<SharePage shareType="board" />} />
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminProtectedRoute><AdminOverview /></AdminProtectedRoute>} />
            <Route path="/admin/users" element={<AdminProtectedRoute><AdminUsers /></AdminProtectedRoute>} />
            <Route path="/admin/waitlist" element={<AdminProtectedRoute><AdminWaitlist /></AdminProtectedRoute>} />
            <Route path="/admin/storage" element={<AdminProtectedRoute><AdminStorage /></AdminProtectedRoute>} />
            <Route path="/admin/ai-usage" element={<AdminProtectedRoute><AdminAIUsage /></AdminProtectedRoute>} />
            <Route path="/admin/error-reports" element={<AdminProtectedRoute><AdminErrorReporting /></AdminProtectedRoute>} />
            <Route path="/admin/settings" element={<AdminProtectedRoute><AdminSettings /></AdminProtectedRoute>} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
